var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_220_1541",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_220_1541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5615 7.61402C14.5615 6.91885 14.334 6.36027 13.879 5.93827C13.4242 5.51643 12.8276 5.30551 12.0893 5.30551C11.6203 5.30551 11.193 5.40168 10.8075 5.59402C10.422 5.78635 10.0878 6.06902 9.80501 6.44202C9.49034 6.81985 9.10184 7.04302 8.63951 7.11152C8.17701 7.18018 7.77426 7.08468 7.43126 6.82502C7.09209 6.58352 6.90317 6.27085 6.86451 5.88702C6.82584 5.50335 6.94143 5.1241 7.21126 4.74926C7.77276 3.96843 8.47201 3.37177 9.30901 2.95927C10.146 2.54677 11.0736 2.34052 12.0918 2.34052C13.7629 2.34052 15.1108 2.81893 16.1353 3.77577C17.1596 4.7326 17.6718 5.9826 17.6718 7.52577C17.6718 8.33077 17.4765 9.11202 17.086 9.86952C16.6953 10.6269 16.0777 11.434 15.233 12.291C14.7953 12.7235 14.4737 13.0942 14.268 13.403C14.0623 13.7117 13.9088 14.0516 13.8075 14.4228C13.6578 14.8334 13.4307 15.161 13.126 15.4055C12.8215 15.6498 12.4898 15.772 12.131 15.772C11.7173 15.772 11.3598 15.6344 11.0585 15.359C10.7572 15.0837 10.6065 14.7531 10.6065 14.3673C10.6065 13.7111 10.7726 13.0782 11.1048 12.4685C11.4369 11.8588 11.9311 11.289 12.5873 10.759C13.3056 10.1687 13.8143 9.63243 14.1133 9.15027C14.4121 8.66793 14.5615 8.15585 14.5615 7.61402ZM12.0883 22.4428C11.4814 22.4428 10.9651 22.2294 10.5393 21.8025C10.1133 21.3757 9.90026 20.8598 9.90026 20.2548C9.90026 19.6498 10.1134 19.1335 10.5398 18.706C10.9661 18.2785 11.4837 18.0648 12.0925 18.0648C12.7012 18.0648 13.2192 18.279 13.6465 18.7075C14.074 19.136 14.2878 19.6528 14.2878 20.2578C14.2878 20.8628 14.0728 21.3782 13.643 21.804C13.2133 22.2299 12.6951 22.4428 12.0883 22.4428Z",
    fill: "#FCAD09"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkActive);
export default __webpack_public_path__ + "static/media/question_mark_active.8f5ea8e21f92ab5ccf90b4338ed76855.svg";
export { ForwardRef as ReactComponent };